import { render, staticRenderFns } from "./Timecard.vue?vue&type=template&id=d5645462&scoped=true&"
import script from "./Timecard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Timecard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Timecard.vue?vue&type=style&index=0&id=d5645462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5645462",
  null
  
)

export default component.exports